import Close from "@mui/icons-material/Close";
import Refresh from "@mui/icons-material/Refresh";
import { Theme } from "@mui/material";
import Alert, { AlertColor } from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

interface Props {
    message: string | undefined | false;
    severity?: AlertColor;
    className?: string;
    onClose?: () => void;
    alertClassName?: string;
    action?: ToastAction;
    noIcon?: boolean;
    testId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    actionButton: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    actionButtonIcon: {
        color: theme.palette.primary.contrastText,
        marginRight: "0.5rem"
    },
    alert: {
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    message: {
        whiteSpace: "pre-wrap",
        // Enough for 5 lines of text
        maxHeight: "5.5rem",
        display: "block",
        overflow: "hidden"
    }
}));

export const Toast: React.FC<Props> = props => {
    const classes = useStyles();

    if (props.action && props.onClose) {
        throw new Error("Only action or onClose must be passed!");
    }

    return (
        <Collapse
            in={!!props.message}
            className={props.className}>

            <Alert
                data-cy={props.testId}
                icon={props.noIcon ? false : undefined}
                variant="filled"
                onClose={props.onClose}
                severity={props.severity || "error"}
                className={clsx(classes.alert, props.alertClassName)}
                action={props.action?.onClick && (

                    <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        className={classes.actionButton}
                        size="small"
                        onClick={props.action.onClick}>

                        {React.createElement(props.action.icon, {
                            fontSize: "small",
                            className: classes.actionButtonIcon
                        })}

                    </IconButton>

                )}>

                <span className={classes.message}>
                    {props.message}
                </span>

            </Alert>

        </Collapse>
    );
};

export interface ToastAction {
    icon: React.ElementType;
    onClick: (() => void) | undefined;
}

export const retryAction = (onRetry: (() => void) | undefined): ToastAction => ({
    onClick: onRetry,
    icon: Refresh
});

export const closeAction = (onClose: (() => void) | undefined): ToastAction => ({
    onClick: onClose,
    icon: Close
});
